import {
  BaseFlowBlockSchema,
  FlowBlockReturnTypeSchema,
  FlowBlockType,
  FlowProducedType,
} from 'flow-schema';
import { z } from 'zod';

import { VoiceCallBlockConfigSchema } from './config.js';

export { VoiceCallBlockConfigSchema };

export const VoiceCallV2BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(FlowBlockType.VoiceCallV2),
  config: VoiceCallBlockConfigSchema,
  returnType: FlowBlockReturnTypeSchema(FlowProducedType.VoiceCallV2),
});
export type VoiceCallV2Block = z.infer<typeof VoiceCallV2BlockSchema>;
